<template>
    <div v-if="getCompanyDetail.data">
        <!-- home->show->edit->confirm2->edit->show->home -->
        <div v-if="showItem" class="container p-0">
            <div class="card mb-2">
                <div class="card-body pt-3">
                    <div class="text-center text-muted border mb-3 py-2"><span>{{pageName}}</span></div>

                    <form-item lab="会社名">
                        <div class="d-flex">
                            <span v-if="form.id">({{form.id}})</span>
                            <span>{{form.name}}</span>
                        </div>
                    </form-item>

                    <form-item lab="グループ名">{{form.user_group}}</form-item>

                    <form-item v-if="opt == 'show'" lab="メール送信グループ">
                        <a href="#" @click.prevent="openGroupMembers" >メール送信グループ設定</a>
                    </form-item>

                    <form-item v-if="form.url" lab="ホームページURL">
                        <a :href="form.url" target="_blank">{{form.url}}</a>
                    </form-item>
                    <form-item v-else lab="ホームページURL"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.country" lab="国籍">{{form.country}}</form-item>
                    <form-item v-else lab="国籍"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.email_lev" lab="優先度">{{form.email_lev}}</form-item>
                    <form-item v-else lab="優先度"><span class="text-danger">未入力</span></form-item>

                    <form-item lab="メール送信状態">{{form.email_flg == '0' ? '有効' : '無効'}}</form-item>

                    <form-item v-if="form.sales_name" lab="担当者名">{{form.sales_name}}</form-item>
                    <form-item v-else lab="担当者名"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.sales_mail" lab="配信宛先">{{form.sales_mail}}</form-item>
                    <form-item v-else lab="配信宛先"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.sales_mail_cc" lab="配信CC">{{form.sales_mail_cc}}</form-item>
                    <form-item v-else lab="配信CC"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.note" lab="備考">{{form.note}}</form-item>
                    <form-item v-else lab="備考"><span class="text-danger">未入力</span></form-item>
        
                    <div class="card mb-2 mt-5">
                        <div class="card-body">
                            <div v-if="opt == 'edit_confirm'" class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3 mb-3">
                                    <button class="btn btn-primary btn-block btn-lg" @click="backPage">
                                        <i class="fas fa-angle-left"></i>&nbsp;戻る
                                    </button>
                                </div>
                                <div class="col-sm-3 mb-3">
                                    <button class="btn btn-danger btn-block btn-lg" @click="doSubmit">
                                        <i class="fas fa-save"></i>&nbsp;会社情報更新
                                    </button>
                                </div>
                            </div>
                            <div v-if="opt == 'show'" class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3 mb-3">
                                    <button class="btn btn-danger btn-block btn-lg" @click="deleteCompany(form.user_group)" :disabled="form.has_member">
                                        <i class="fas fa-trash"></i>&nbsp;削除
                                    </button>
                                </div>
                                <div class="col-sm-3 mb-3">
                                    <button class="btn btn-success btn-block btn-lg" @click="doEdit">
                                        <i class="fas fa-edit"></i>&nbsp;会社情報編集
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 0件メッセージ -->
        <not-found-msg v-else></not-found-msg>
    </div>
</template>

<script>
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    import FormItem from 'pages/commons/form/Confirm'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            form: Object,
            opt: String
        },
        components: {
            FormItem,
            NotFoundMsg
        },
        computed: {
            showItem () {
                return Object.keys(this.form).length > 0
            },
            pageName () {
                if (this.opt == 'edit_confirm') {
                    return "編集内容確認"
                }
                return "法人情報"
            },
            ...mapGetters(['getCompanyDetail'])
        },
        methods: {
            backPage () {
                if (this.opt == 'edit_confirm') {
                    this.$parent.changeOperat('edit')
                }
            },
            doSubmit () {
                this.$parent.doSubmit()
            },
            deleteCompany (id) {
                this.$parent.openMsg(2,'この法人を削除しますか？','deleteCompany', id)
            },
            doEdit () {
                this.$parent.changeOperat('edit')
            },
            openGroupMembers (type, id) {
                this.$router.push({name:'SysMailGroup', params: {
                    type:'partner',
                    group:'partner'
                }})
            },
        }
    }
</script>

<style>

</style>
